export default __webpack_public_path__ + "static/media/category_16.5cdab4ee.png";